/**
 * Literal content the superadmin screens used to hardcode, now read from
 * `platform_baseline_definitions` so editing a prompt card or a role list is a
 * save on the Platform Definitions screen rather than a deploy.
 *
 * The values below are the same seed the backend writes. They are the fallback,
 * not the source: a screen must still render if the fetch fails or a definition
 * was deactivated, and rendering nothing would look like a broken page.
 */
export const UI_CONTENT_KEYS = {
  AI_PROMPT_LANES: 'ui.superadmin.ai_prompt_lanes',
  ACCESS_PRECEDENCE: 'ui.access_control.precedence',
  ACCESS_ROLE_OPTIONS: 'ui.access_control.role_options',
};

export const UI_CONTENT_FALLBACK = {
  [UI_CONTENT_KEYS.AI_PROMPT_LANES]: [
    {
      title: 'Tenant Risk Watch',
      summary: 'Compare tenants with the sharpest attrition and compliance drag.',
      accent: 'from-rose-500/10 via-card to-card',
    },
    {
      title: 'Payroll Exposure Scan',
      summary: 'Summarize payroll movement, anomalies, and pending collection pressure.',
      accent: 'from-amber-500/10 via-card to-card',
    },
    {
      title: 'Governance Readiness',
      summary: 'Inspect model health, policy coverage, and approval bottlenecks.',
      accent: 'from-primary/10 via-card to-card',
    },
  ],
  [UI_CONTENT_KEYS.ACCESS_PRECEDENCE]: [
    'user_override', 'deny', 'allow', 'permission_group', 'role', 'default_deny',
  ],
  [UI_CONTENT_KEYS.ACCESS_ROLE_OPTIONS]: [
    'workspace_admin', 'hr_admin', 'manager', 'hr_manager', 'employee',
  ],
};

